<template>
  <PageTemplate>
    <h1>Outstanding Activities</h1>
    <div class="row">
      <div class="col-xl-6 d-flex">
        <v-card title="Pending Registrations">
          <template #header>
            <v-button
              color="transparent"
              size="sm"
              @click="$router.push('/admin/pending-registration-all')"
            >
              <v-icon type="show" />
              View all Pending Registrations
            </v-button>
          </template>
          <v-table
            :table="pendingRegistrations"
          />
        </v-card>
      </div>
      <div class="col-xl-6 d-flex">
        <v-card title="Pending Profile Changes">
          <template #header>
            <v-button
              color="transparent"
              size="sm"
              @click="$router.push('/admin/pending-profile-change-all')"
            >
              <v-icon type="show" />
              View all Pending Profile Changes
            </v-button>
          </template>
          <v-table
            :table="pendingChanges"
          />
        </v-card>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import {buildBreadCrumb, columnSort, columnFilter} from "@/common/tableFunctions"
  import { mapState } from "vuex";
  import {GET_USER_REQUEST} from "../../store/actions.type";

  export default {
    name: "OutstandingActivities",
    components: {
      "v-card": Card,
      "v-table": Table,
      "v-button": Button,
      "v-icon": Icon,
      PageTemplate
    },
    data: () => ({
      pendingRegistrations: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'User Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Role',
            field: 'role',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Role',
              filterFn: columnFilter
            },
          }
        ],
        rows: []
      },
      pendingChanges: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'User Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Role',
            field: 'role',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Role',
              filterFn: columnFilter
            },
          },
          {
            label: 'Change Request',
            field: 'request',
            sortFn: columnSort,
            thClass: 'sortable',
            filterOptions: {
              enabled: true,
              placeholder: 'Request',
              filterFn: columnFilter
            },
          }
        ],
        rows: []
      }
    }),
    computed:{
      ...mapState({
        registrations: state => state.userRequest.registrations,
        profileChanges: state => state.userRequest.profileChanges,
      })
    },
    mounted() {
      this.updateBreadCrumb();
      this.updateTable();
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Outstanding Activities'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      updateTable: function(){
        this.$store.dispatch(GET_USER_REQUEST).then(response => {
          this.pendingRegistrations.rows = this.registrations;
          this.pendingChanges.rows = this.profileChanges;
        })
      },
      selectRegistration:function(){
        console.log('selectRegistration')
      }
    }
  }
</script>

